import type { Color } from "@clovis/server/src/app/config/colors/colors";
import { colorToHexValues } from "@clovis/server/src/app/config/colors/colors";
import { PencilIcon } from "@heroicons/react/outline";
import * as React from "react";
import { Dot } from "~/design-system/Badge";
import { Box } from "~/design-system/Box";
import { Button } from "~/design-system/Button";
import { Column, Columns } from "~/design-system/Columns";
import { Text } from "~/design-system/Text";
import type { TeamsList_ItemFragment } from "./UpdateTeamForm/UpdateTeamForm.graphql";

type InfosProps = {
  team: TeamsList_ItemFragment;
  onEditClick: () => void;
};

function Infos(props: InfosProps) {
  const color = colorToHexValues.get(props.team.color as Color)!.base;

  return (
    <Columns space="small">
      <Column>
        <Box display="flex" alignItems="center" height="full">
          <Box>
            <Dot size="large" css={{ color }} />
          </Box>
          <Text css={{ color }}>{props.team.name}</Text>
        </Box>
      </Column>
      <Column width="content" css={{ alignItems: "center", display: "flex" }}>
        <Button
          type="button"
          variant="transparent"
          circular
          onClick={props.onEditClick}
          dataClovisActionId="project-teams-edit"
        >
          <PencilIcon />
        </Button>
      </Column>
    </Columns>
  );
}

export { Infos };
